import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Cushion, Grid, Rectangle, Space, Shadow, Typography } from '@pitchero/react-ui';
import { Trans } from '../../../lib/i18n';

const FixtureStatistics = ({ includePlayedCount, played, W, L, D, style, ...otherProps }) => {
  const [isMounted, setIsMounted] = useState();
  useEffect(() => setIsMounted(true), []);
  const winRatio = isMounted ? (W / played) * 100 : 0;
  const lostRatio = isMounted ? (L / played) * 100 : 0;

  return (
    <Shadow {...otherProps} style={style}>
      <Rectangle fill="white" radius="rounded">
        <Cushion
          all="medium"
          responsive={[
            { minWidth: 'palm', props: { all: 'large' } },
            { minWidth: 'tab', props: { horizontal: 'large', vertical: 'medium' } },
          ]}
        >
          <Grid
            className={includePlayedCount ? 'ie-grid-four-col' : 'ie-grid-three-col'}
            columns={`repeat(${includePlayedCount ? 4 : 3}, minmax(0, 1fr))`}
            columnGap="medium"
            rowGap="xsmall"
            justifyContent="center"
            justifyItems="center"
            responsive={[{ minWidth: 'lap', props: { columnGap: 'xlarge' } }]}
          >
            {includePlayedCount && (
              <Typography preset="title" color="dustygrey">
                {played}
              </Typography>
            )}
            <Typography preset="title" color="positive">
              {W}
            </Typography>
            <Typography preset="title" color="dustygrey">
              {D}
            </Typography>
            <Typography preset="title" color="negative">
              {L}
            </Typography>
            {includePlayedCount && (
              <Typography preset="tag--large" color="silver">
                <Trans i18nKey="teams:fixture_statistics_played">Played</Trans>
              </Typography>
            )}
            <Typography preset="tag--large" color="silver">
              <Trans i18nKey="teams:fixture_statistics_won">Won</Trans>
            </Typography>
            <Typography preset="tag--large" color="silver">
              <Trans i18nKey="teams:fixture_statistics_drawn">Drawn</Trans>
            </Typography>
            <Typography preset="tag--large" color="silver">
              <Trans i18nKey="teams:fixture_statistics_lost">Lost</Trans>
            </Typography>
          </Grid>
          <Space top="medium">
            <Rectangle radius="rounded" style={{ height: 20, overflow: 'hidden' }}>
              <Rectangle
                fill="positive"
                style={{
                  height: 20,
                  width: `${winRatio}%`,
                  transition: 'width .5s ease-in-out',
                  display: 'inline-block',
                }}
              />
              <Rectangle
                fill="mercury"
                style={{
                  height: 20,
                  width: `${100 - winRatio - lostRatio}%`,
                  transition: 'width .5s ease-in-out',
                  display: 'inline-block',
                }}
              />
              <Rectangle
                fill="negative"
                style={{
                  height: 20,
                  width: `${lostRatio}%`,
                  transition: 'width .5s ease-in-out',
                  display: 'inline-block',
                }}
              />
            </Rectangle>
          </Space>
        </Cushion>
      </Rectangle>
    </Shadow>
  );
};

FixtureStatistics.defaultProps = {
  includePlayedCount: false,
  style: {},
};

FixtureStatistics.propTypes = {
  includePlayedCount: PropTypes.bool,
  played: PropTypes.number.isRequired,
  W: PropTypes.number.isRequired,
  L: PropTypes.number.isRequired,
  D: PropTypes.number.isRequired,
  style: PropTypes.shape(),
};

export default FixtureStatistics;
